import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, vShow as _vShow, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e76db08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "newlive_wrap" }
const _hoisted_2 = { class: "mod_c_title watch_title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "关闭后无法访问直播间", -1))
const _hoisted_4 = { class: "newlive" }
const _hoisted_5 = { class: "newlive_content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "newlive_content_name" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "newlive_content_required" }, "*"),
  /*#__PURE__*/_createTextVNode(" 活动名称： ")
], -1))
const _hoisted_7 = { class: "text_number" }
const _hoisted_8 = { class: "newlive_content" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "newlive_content_name" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "newlive_content_required" }, "*"),
  /*#__PURE__*/_createTextVNode(" 起始时间： ")
], -1))
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "newlive_content_to" }, "至", -1))
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  class: "newlive_content",
  style: {"margin-bottom":"24px"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "newlive_content_name" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "newlive_content_required" }, "*"),
  /*#__PURE__*/_createTextVNode(" 直播模式： ")
], -1))
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  class: "newlive_content newlive_contents"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "newlive_content_name" }, "添加频道：", -1))
const _hoisted_18 = {
  key: 1,
  class: "newlive_content"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "newlive_content_name" }, "直播状态：", -1))
const _hoisted_20 = {
  key: 2,
  class: "newlive_content"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "newlive_content_name" }, "页面语言：", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pageColor" }, "AUTO", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pageColor" }, "ZH", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pageColor" }, "EN", -1))
const _hoisted_25 = {
  key: 3,
  class: "newlive_content"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "newlive_content_name" }, "颜色设置：", -1))
const _hoisted_27 = {
  key: 4,
  class: "newlive_content"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "newlive_content_name" }, "序号开关：", -1))
const _hoisted_29 = {
  key: 5,
  class: "newlive_content"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "newlive_content_name" }, "频道样式：", -1))
const _hoisted_31 = {
  key: 6,
  class: "newlive_content"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "newlive_content_name" }, "聊天模式：", -1))
const _hoisted_33 = {
  key: 0,
  class: "newlive_content_tip"
}
const _hoisted_34 = {
  key: 7,
  class: "newlive_content"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "newlive_content_name" }, "人数显示：", -1))
const _hoisted_36 = {
  key: 8,
  class: "newlive_content"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "newlive_content_name" }, "观看人数：", -1))
const _hoisted_38 = {
  key: 9,
  class: "newlive_content"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "newlive_content_name" }, " 主题模式： ", -1))
const _hoisted_40 = { class: "channer_fixed" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = ["src"]
const _hoisted_43 = { class: "channer_fixed_txt" }
const _hoisted_44 = {
  key: 10,
  class: "newlive_content"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "newlive_content_name" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "newlive_content_required" }, "*"),
  /*#__PURE__*/_createTextVNode(" 所属行业： ")
], -1))
const _hoisted_46 = {
  key: 11,
  class: "newlive_content"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "newlive_content_name" }, "并发上限：", -1))
const _hoisted_48 = { class: "newlive_number" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "0表示无观看人数上限", -1))
const _hoisted_50 = {
  key: 12,
  class: "newlive_content agreement"
}
const _hoisted_51 = { class: "agreement_check" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.qing.tv/law/service-agreement",
  target: "blank"
}, "服务协议", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.qing.tv/law/privacy",
  target: "blank"
}, "隐私政策", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.qing.tv/law/anchor-specification",
  target: "blank"
}, "网络主播行为规范", -1))
const _hoisted_55 = {
  key: 0,
  class: "ninetyNine"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ninetyNine_title" }, "活动规则：", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ninetyNine_content" }, [
  /*#__PURE__*/_createTextVNode(" 1. 已完成注册的新用户，即可参与“99元开播”体验服务；"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 2. 直播间时长超过12小时将不能享受“99元开播”体验服务；"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 3. “99元开播”直播间创建后不支持修改时间；"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 4. “99元开播”直播间创建后不支持解除绑定；"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 5. 参与以上活动的用户，在已设置的直播时间前开启直播，最高支持10个并发量；"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 6. 参与以上活动的用户，在直播间结束后，系统会自动停止推流；"),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_58 = [
  _hoisted_56,
  _hoisted_57
]
const _hoisted_59 = { class: "newlive_bottom" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "99元直播间创建后，时间将不可更改，是否确定创建？", -1))
const _hoisted_61 = { class: "newlive_wxPay" }
const _hoisted_62 = { class: "newlive_wxPay_money" }
const _hoisted_63 = ["src"]
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "newlive_wxPay_tip" }, "请用微信扫码支付", -1))
const _hoisted_65 = { class: "norm_box" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "norm_box_txt" }, [
  /*#__PURE__*/_createElementVNode("p", null, " 我接受 “”《法律声明》《服务协议》《隐私政策》等相关条款，严格遵守包括中华人民共和国《网络主播行为规范》等在内的相关法律法规，以及国际性法和公约的相关规定，并承诺在直播开始前完成对涉及专业领域的直播活动进行备案。 "),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" 该直播帐户的“拥有者”和“活动组织者”对传播内容全权共同承担责任。 更多详情，请参阅相关"),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.qing.tv/law/statement",
      target: "blank"
    }, "”法律及合规声明“"),
    /*#__PURE__*/_createTextVNode("。 ")
  ])
], -1))
const _hoisted_67 = { class: "norm_btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Crumb = _resolveComponent("Crumb")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_QuestionCircleFilled = _resolveComponent("QuestionCircleFilled")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_ColorInstalls = _resolveComponent("ColorInstalls")!
  const _component_CheckCircleFilled = _resolveComponent("CheckCircleFilled")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_CloseCircleFilled = _resolveComponent("CloseCircleFilled")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_AnchorNorm = _resolveComponent("AnchorNorm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Crumb),
      _createElementVNode("div", {
        class: "mod_wrap mod_c",
        onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.getPicker && _ctx.getPicker(...args)))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.studioId ? '频道编辑' : !_ctx.title || _ctx.title == 'false' ? '99元开播' : '创建直播') + " ", 1),
          (_ctx.studioId)
            ? (_openBlock(), _createBlock(_component_a_switch, {
                key: 0,
                class: "switch",
                onChange: _ctx.checkLiveOpen,
                checked: _ctx.liveOpen,
                "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.liveOpen) = $event))
              }, null, 8, ["onChange", "checked"]))
            : _createCommentVNode("", true),
          (_ctx.studioId)
            ? (_openBlock(), _createBlock(_component_a_popover, {
                key: 1,
                placement: "right",
                class: "switch_tips"
              }, {
                content: _withCtx(() => [
                  _hoisted_3
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_QuestionCircleFilled)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_a_input, {
              class: "newlive_content_right",
              onChange: _ctx.getInput,
              value: _ctx.domain,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.domain) = $event)),
              placeholder: "请输入活动名称",
              maxlength: 80,
              size: "small"
            }, {
              suffix: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.domain.length) + "/80", 1)
              ]),
              _: 1
            }, 8, ["onChange", "value"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_a_date_picker, {
              class: "newlive_content_picker",
              value: _ctx.startTime,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.startTime) = $event)),
              "disabled-date": _ctx.disabledStartDate,
              "show-time": { format: 'HH:mm' },
              format: "YYYY-MM-DD HH:mm",
              placeholder: "选择日期",
              onOpenChange: _ctx.handleStartOpenChange,
              size: "large"
            }, {
              suffixIcon: _withCtx(() => [
                _createElementVNode("img", {
                  class: "RangePickerIcon",
                  src: _ctx.RangePickerIcon,
                  alt: ""
                }, null, 8, _hoisted_10)
              ]),
              _: 1
            }, 8, ["value", "disabled-date", "onOpenChange"]),
            _hoisted_11,
            _createVNode(_component_a_date_picker, {
              class: "newlive_content_picker",
              value: _ctx.endTime,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.endTime) = $event)),
              "disabled-date": _ctx.disabledEndDate,
              "show-time": { format: 'HH:mm' },
              format: "YYYY-MM-DD HH:mm",
              placeholder: "选择日期",
              open: _ctx.endOpen,
              onOpenChange: _ctx.handleEndOpenChange,
              size: "large"
            }, {
              suffixIcon: _withCtx(() => [
                _createElementVNode("img", {
                  class: "RangePickerIcon",
                  src: _ctx.RangePickerIcon,
                  alt: ""
                }, null, 8, _hoisted_12)
              ]),
              _: 1
            }, 8, ["value", "disabled-date", "open", "onOpenChange"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_a_alert, {
              class: "newlive_content_alert",
              message: "直播模式创建后，模式将不能进行修改！",
              type: "warning",
              "show-icon": ""
            })
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["newlive_mode", { newlive_modes: !_ctx.VerticalLive }])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modeList, (item) => {
              return _withDirectives((_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["newlive_mode_type", item.id == _ctx.modeId ? 'newlive_mode_types' : '']),
                key: item.id,
                onClick: _withModifiers(($event: any) => (_ctx.getMode(item.id)), ["stop"]),
                style: _normalizeStyle({ cursor: _ctx.studioId ? 'not-allowed' : 'pointer' })
              }, [
                _createVNode(_component_svg_icon, {
                  class: "newlive_mode_type_icon",
                  "icon-class": item.icon
                }, null, 8, ["icon-class"]),
                _createElementVNode("div", null, _toDisplayString(item.name), 1)
              ], 14, _hoisted_15)), [
                [_vShow, item.show]
              ])
            }), 128))
          ], 2),
          (_ctx.studioId ? (_ctx.modeId == 4 && !_ctx.langSubEdit) || (_ctx.modeId == 5 && !_ctx.langSubEdit) : _ctx.modeId == 4 || _ctx.modeId == 5)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _hoisted_17,
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modeList[_ctx.modeId == 4 ? 2 : 3].component), { ref: "componentValue" }, null, 512))
              ]))
            : _createCommentVNode("", true),
          (_ctx.VRLiveRole)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(_component_a_checkbox_group, {
                  value: _ctx.vr_play_status,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.vr_play_status) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_checkbox, { value: "0" }, {
                      default: _withCtx(() => [
                        _createTextVNode("2D")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_checkbox, { value: "1" }, {
                      default: _withCtx(() => [
                        _createTextVNode("VR")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ], 512)), [
                [_vShow, _ctx.modeId == 0]
              ])
            : _createCommentVNode("", true),
          (_ctx.modeId !== 5)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _hoisted_21,
                _createVNode(_component_a_radio_group, {
                  name: "radioGroup",
                  value: _ctx.page_language,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.page_language) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: "0" }, {
                      default: _withCtx(() => [
                        _createTextVNode("自动("),
                        _hoisted_22,
                        _createTextVNode(")")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: "1" }, {
                      default: _withCtx(() => [
                        _createTextVNode("中文("),
                        _hoisted_23,
                        _createTextVNode(")")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: "2" }, {
                      default: _withCtx(() => [
                        _createTextVNode("英文("),
                        _hoisted_24,
                        _createTextVNode(")")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.studioId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _hoisted_26,
                _createVNode(_component_ColorInstalls, {
                  ref: "picker",
                  title: _ctx.domain
                }, null, 8, ["title"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.studioId ? _ctx.modeId == 4 && !_ctx.langSubEdit : _ctx.modeId == 4)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _hoisted_28,
                _createVNode(_component_a_switch, {
                  "checked-children": "开",
                  "un-checked-children": "关",
                  checked: _ctx.serial,
                  "onUpdate:checked": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.serial) = $event)),
                  onChange: _ctx.getSerial
                }, null, 8, ["checked", "onChange"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.studioId ? _ctx.modeId == 4 && !_ctx.langSubEdit : _ctx.modeId == 4)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _hoisted_30,
                _createVNode(_component_a_radio_group, {
                  name: "radioGroup",
                  value: _ctx.channel_style,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.channel_style) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: "1" }, {
                      default: _withCtx(() => [
                        _createTextVNode("列表式")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: "2" }, {
                      default: _withCtx(() => [
                        _createTextVNode("模块式")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.studioId ? _ctx.modeId !== 4 : !_ctx.studioId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _hoisted_32,
                _createVNode(_component_a_radio_group, {
                  name: "radioGroup",
                  value: _ctx.chat_type,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.chat_type) = $event)),
                  disabled: _ctx.studioId && (_ctx.modeId == 6 || _ctx.modeId == 3 || (_ctx.studioPid !== parseInt(_ctx.studioId as string) && _ctx.modeId == 5))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: "1" }, {
                      default: _withCtx(() => [
                        _createTextVNode("轻聊版")
                      ]),
                      _: 1
                    }),
                    (_ctx.modeId !== 6 && _ctx.modeId !== 3 && [_ctx.StandardLiveRole || (_ctx.studioId && _ctx.chat_type === '2')])
                      ? (_openBlock(), _createBlock(_component_a_radio, {
                          key: 0,
                          value: "2",
                          disabled: !_ctx.StandardLiveRole
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("标准版")
                          ]),
                          _: 1
                        }, 8, ["disabled"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["value", "disabled"]),
                (_ctx.studioId && _ctx.modeId != 3 && _ctx.modeId != 6)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, "（切换聊天模式将清空原有聊天记录）"))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.studioId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _hoisted_35,
                _createVNode(_component_a_switch, {
                  "checked-children": "开",
                  "un-checked-children": "关",
                  checked: _ctx.people_num,
                  "onUpdate:checked": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.people_num) = $event)),
                  onChange: _ctx.getWatch
                }, null, 8, ["checked", "onChange"])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.studioId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _hoisted_37,
                _createVNode(_component_a_radio_group, {
                  name: "radioGroup",
                  value: _ctx.people_mode,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.people_mode) = $event)),
                  onChange: _ctx.getPeople
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: "1" }, {
                      default: _withCtx(() => [
                        _createTextVNode("实时在线")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: "2" }, {
                      default: _withCtx(() => [
                        _createTextVNode("用户量")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: "3" }, {
                      default: _withCtx(() => [
                        _createTextVNode("累计访问量（支持人数放大）")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value", "onChange"])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.studioId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("div", _hoisted_40, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.styleGlobal, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.key,
                      class: _normalizeClass(["channer_fixed_img", { actived: _ctx.dark_mode === item.key }]),
                      onClick: ($event: any) => (_ctx.clickTabs(item.key))
                    }, [
                      _createElementVNode("img", {
                        src: item.url
                      }, null, 8, _hoisted_42),
                      _createElementVNode("div", _hoisted_43, _toDisplayString(item.title), 1),
                      _withDirectives(_createVNode(_component_CheckCircleFilled, { class: "channer_fixed_icon" }, null, 512), [
                        [_vShow, _ctx.dark_mode === item.key]
                      ])
                    ], 10, _hoisted_41))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.studioId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                _hoisted_45,
                _createVNode(_component_a_select, {
                  value: _ctx.industry,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.industry) = $event)),
                  class: "newlive_content_people",
                  options: _ctx.options,
                  placeholder: "请选择所属行业"
                }, null, 8, ["value", "options"])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.studioId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                _hoisted_47,
                _createVNode(_component_a_input, {
                  value: _ctx.concurrent,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.concurrent) = $event)),
                  class: _normalizeClass(["newlive_content_people", _ctx.concurrentTips ? 'newlive_content_peoples' : '']),
                  placeholder: "0",
                  size: "small",
                  onChange: _ctx.getConcurrent
                }, {
                  suffix: _withCtx(() => [
                    _withDirectives(_createVNode(_component_CloseCircleFilled, { class: "people_icon" }, null, 512), [
                      [_vShow, _ctx.concurrentTips]
                    ])
                  ]),
                  _: 1
                }, 8, ["value", "class", "onChange"]),
                _withDirectives(_createElementVNode("div", _hoisted_48, "人数不能为负数", 512), [
                  [_vShow, _ctx.concurrentTips]
                ]),
                _createTextVNode(" 人 "),
                _createVNode(_component_a_popover, {
                  placement: "right",
                  class: "switch_tips"
                }, {
                  content: _withCtx(() => [
                    _hoisted_49
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_QuestionCircleFilled)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (!_ctx.studioId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createVNode(_component_a_checkbox, {
                    checked: _ctx.agreementCheckbox,
                    "onUpdate:checked": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.agreementCheckbox) = $event))
                  }, null, 8, ["checked"])
                ]),
                _createTextVNode(" 我已阅读并接受"),
                _hoisted_52,
                _createTextVNode("、"),
                _hoisted_53,
                _createTextVNode("、"),
                _hoisted_54,
                _createTextVNode("，并承诺在直播开始前完成对涉及专业领域的直播活动进行备案。 ")
              ]))
            : _createCommentVNode("", true)
        ]),
        (!_ctx.title || _ctx.title == 'false')
          ? (_openBlock(), _createElementBlock("div", _hoisted_55, _hoisted_58))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_59, [
          (!_ctx.studioId)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                class: "btn_cancel",
                onClick: _ctx.toCancel
              }, {
                default: _withCtx(() => [
                  _createTextVNode("取消")
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (!_ctx.studioId)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 1,
                class: "btn_establish",
                type: "primary",
                onClick: _ctx.toCreate
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 创建 ")
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.studioId)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 2,
                class: "btn_establish",
                type: "primary",
                onClick: _ctx.setStudio,
                disabled: _ctx.disabled
              }, {
                default: _withCtx(() => [
                  _createTextVNode("保存")
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_a_modal, {
          title: "99元开播",
          visible: _ctx.visible,
          "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.visible) = $event)),
          centered: true,
          onOk: _ctx.createNinetyNine
        }, {
          default: _withCtx(() => [
            _hoisted_60
          ]),
          _: 1
        }, 8, ["visible", "onOk"]),
        _createVNode(_component_a_modal, {
          title: "收银台",
          visible: _ctx.wxVisible,
          "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.wxVisible) = $event)),
          centered: true,
          footer: null,
          onCancel: _ctx.cancelWxpay
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.amount) + "元", 1),
              (_ctx.qrcodeUrl)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.qrcodeUrl,
                    alt: "QR Code"
                  }, null, 8, _hoisted_63))
                : _createCommentVNode("", true),
              _hoisted_64
            ])
          ]),
          _: 1
        }, 8, ["visible", "onCancel"])
      ])
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.showNorm,
      "onUpdate:visible": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.showNorm) = $event)),
      centered: "",
      width: "895px",
      closable: false,
      maskClosable: false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_65, [
          _hoisted_66,
          _createElementVNode("div", _hoisted_67, [
            _createVNode(_component_a_button, {
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showNorm = false)),
              class: "norm_btn_nav"
            }, {
              default: _withCtx(() => [
                _createTextVNode("不同意")
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: _ctx.createLive,
              loading: _ctx.createLoading,
              disabled: _ctx.readDisabled
            }, {
              default: _withCtx(() => [
                _createTextVNode("同意")
              ]),
              _: 1
            }, 8, ["onClick", "loading", "disabled"])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_AnchorNorm, { "onScroll:bottom": _ctx.onBottom }, null, 8, ["onScroll:bottom"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}